import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authActions } from "../../Actions";

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    dispatch(authActions.logout());
    useEffect(() => {  
        navigate("/login");
    }, []);
    return (
        <><h1>Something went wrong</h1></>
    );
}

export default Logout;